// Notification API Service
import api from "./api";

const notificationApi = {
  // Get notifications list with pagination
  getNotifications: async (params = {}) => {
    const { page = 1, page_size = 20, notification_type, is_read, entity_type } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      page_size: page_size.toString(),
    });

    if (notification_type) queryParams.append("notification_type", notification_type);
    if (is_read !== undefined) queryParams.append("is_read", is_read.toString());
    if (entity_type) queryParams.append("entity_type", entity_type);

    const response = await api.get(`/api/notifications/?${queryParams.toString()}`);
    return response;
  },

  // Get unread count
  getUnreadCount: async () => {
    const response = await api.get("/api/notifications/unread-count");
    return response;
  },

  // Mark notification as read
  markAsRead: async (notificationId) => {
    const response = await api.patch(`/api/notifications/${notificationId}/read`);
    return response;
  },

  // Mark all as read
  markAllAsRead: async () => {
    const response = await api.patch("/api/notifications/mark-all-read");
    return response;
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    const response = await api.delete(`/api/notifications/${notificationId}`);
    return response;
  },

  // Clear all notifications
  clearAll: async () => {
    const response = await api.delete("/api/notifications/clear-all");
    return response;
  },

  // FCM Token Management
  registerFCMToken: async (fcmToken) => {
    const response = await api.post("/api/notifications/fcm-token", {
      fcm_token: fcmToken,
    });
    return response;
  },

  getFCMTokens: async () => {
    const response = await api.get("/api/notifications/fcm-tokens");
    return response;
  },

  deleteFCMToken: async (tokenId) => {
    const response = await api.delete(`/api/notifications/fcm-token/${tokenId}`);
    return response;
  },

  // Notification Preferences
  getPreferences: async () => {
    const response = await api.get("/api/notifications/preferences");
    return response;
  },

  updatePreferences: async (preferences) => {
    const response = await api.put("/api/notifications/preferences", preferences);
    return response;
  },
};

export default notificationApi;
